import styled from 'styled-components';

import { useTheme } from '../ThemeContext';
import { FontSize } from '../theme/FontSize';
import { LineHeight } from '../theme/LineHeight';
import { ThemeType } from '../theme/Theme';

// eslint-disable-next-line
enum Alignment {
  start = 'start',
  center = 'center',
  end = 'end',
}

export interface ParagraphProps {
  fontSize?: keyof typeof FontSize;
  children?: React.ReactNode;
  color?: keyof ThemeType;
  align?: keyof typeof Alignment;
  textDecoration?: React.CSSProperties['textDecoration'];
  fontWeight?: React.CSSProperties['fontWeight'];
  cutText?: boolean;
  style?: React.CSSProperties;
  wordBreak?: React.CSSProperties['wordBreak'];
  lineHeight?: React.CSSProperties['lineHeight'];
  direction?: React.CSSProperties['direction'];
  as?: React.ElementType;
  dangerouslySetInnerHTML?: { __html: string };
}

const P = styled.p<ParagraphProps>`
  font-size: ${(props) => FontSize[props.fontSize || 'm']};
  color: ${(props) =>
    props.color ? props.theme[props.color] : props.theme['fgPrimary']};
  text-align: ${(props) => (props.align ? Alignment[props.align] : 'start')};
  text-decoration: ${({ textDecoration }) => textDecoration};
  font-weight: ${({ fontWeight }) => fontWeight};
  text-overflow: ${(props) => (props.cutText ? 'ellipsis' : 'auto')};
  word-break: ${(props) => props.wordBreak};
  white-space: ${(props) => (props.cutText ? 'nowrap' : 'normal')};
  line-height: ${({ fontSize, lineHeight }) =>
    lineHeight || LineHeight[fontSize || 'm']};
  direction: ${({ direction }) => direction || 'auto'};
  overflow: ${({ cutText }) => (cutText ? 'hidden' : '')};
`;

export const Text: React.FC<ParagraphProps> = (props) => {
  const { theme } = useTheme();

  return <P {...props} theme={theme}></P>;
};
